import React from 'react'
import { useLocation } from 'react-router-dom'
import { FeatureFlag, Tabs } from '~/components/shared'
import { GenomicRiskScore, MetabolicSyndromePrediction } from '~/components/analyticalModels'
import { message } from '~/services'
import { capitalize } from '~/utils'

type BreastCancerPrs = 'breastCancerPrs'
type MetabolicSyndrome = 'metabolicSyndrome'
type AnalyticalModels = BreastCancerPrs | MetabolicSyndrome

const tabsContentIndex: Record<AnalyticalModels, number> = {
  metabolicSyndrome: 0,
  breastCancerPrs: 1
}

export const AnalyticalModelTabs = (): JSX.Element => {
  const { state } = useLocation()
  const activeTabFromRoute = state as AnalyticalModels

  const activeTab = activeTabFromRoute ? tabsContentIndex[activeTabFromRoute] : 0

  return (
    <Tabs initialSelectedTab={activeTab}>
      <Tabs.Options>
        <Tabs.Item>{capitalize(message('analyticalModels.metabolic_syndrome_prediction'))}</Tabs.Item>

        <Tabs.Item>
          <FeatureFlag flag="BreastCancerPRS">
            <>{capitalize(message('analyticalModels.genomic_risk_score'))}</>
          </FeatureFlag>
        </Tabs.Item>
      </Tabs.Options>

      <Tabs.Content overflow="hidden">
        <MetabolicSyndromePrediction />
        <FeatureFlag flag="BreastCancerPRS">
          <GenomicRiskScore />
        </FeatureFlag>
      </Tabs.Content>
    </Tabs>
  )
}
